<template>
    <button class="w-full flex items-center justify-center focus:outline-none uppercase text-12 border border-light-gray-4 rounded-md" @click="open">
    Filter
    <div class="relative py-2 px-2">
      <div v-if="hasFilters" class="filter-button-highlight"></div>
      <i class="fas fa-filter ml-8 py-2"></i>
    </div>
  </button>
</template>
<script>

export default {
  inject: ['query'],

  data () {
    return {
      show: false,
    }
  },

  methods: {
    open () {
      window.TheFilterPanelMobile.toggle()
    },
  },

  computed: {
    hasFilters () {
      return this.query.artist !== null
        || this.query.categories.length > 0
        || this.query.media.length > 0
        || this.query.orientations.length > 0
        || this.query.prices.length > 0
        || this.query.sizes.length > 0
        || this.query.subjects.length > 0
    }
  },
}
</script>

<style scoped lang="scss">
.filter-button-highlight {
  width: .5rem;
  height: .5rem;
  --bg-opacity: 1;
  background-color: #ff6700;
  background-color: rgba(255, 103, 0, var(--bg-opacity));
  border-radius: 9999px;
  position: absolute;
  right: 0;
  top: 0;
  border-width: 1px;
  --border-opacity: 1;
  border-color: #ffffff;
  border-color: rgba(255, 255, 255, var(--border-opacity));
}
</style>

